import DefaultBanner from "./themes/default/banner";
import { useOutletContext } from "react-router";

import ProductList from "../../productList/component/productList";
import Banner from "./themes/modern/banner";

import { Container } from "../../common/styled";

export default function DefaultTheme() {
  const { cmpnyNo } = useOutletContext();

  return (
    <Container id="contIdx" className="shop_main" style={{ flex: "1" }}>
      {/* <DefaultBanner /> */}
      <Banner cmpnyNo={cmpnyNo} isExpanded={true} />
      <div className="list_info font_color_gray_light" style={{ justifyContent: "center" }}></div>
      <ProductList />
    </Container>
  );
}
